export const siteName = 'Mitchell Simoens'
export const siteTitle = 'Mitchell Simoens Site'
export const siteDescription =
  'Some experiments and thoughts on all things from Mitchell Simoens'

export const locale = 'en'
